module.exports = __webpack_public_path__ + "img/bad-horizontal-stairs.d45524bf.gif";